import {
  elseware_games,
  incbotic,
  lseg,
  maggiesfarm_studio,
  ucsc,
  wso2,
  udemy,
} from "src/assets";

// Function to calculate duration
function calculateDuration(startDate, endDate = new Date()) {
  const start = new Date(startDate);
  const end = endDate === "Present" ? new Date() : new Date(endDate);

  const years = end.getFullYear() - start.getFullYear();
  const months = end.getMonth() - start.getMonth();

  const totalMonths = years * 12 + months;
  const displayYears = Math.floor(totalMonths / 12);
  const displayMonths = totalMonths % 12;

  if (displayYears > 0 && displayMonths > 0) {
    return `${displayYears} yr ${displayMonths} mos`;
  } else if (displayYears > 0) {
    return `${displayYears} yr${displayYears > 1 ? "s" : ""}`;
  } else {
    return `${displayMonths} mos`;
  }
}

export const EXPERIENCES = [
  {
    id: 0,
    company: "Udemy",
    logo: udemy,
    title: "Udemy Instructor",
    startDate: "2025-10-01",
    endDate: "Present",
    location: "Colombo, Western Province, Sri Lanka · Remote",
    description:
      "Representing Elseware Games as a game development instructor, creating and publishing educational courses focused on Unreal Engine, scalable game systems, and real-world development practices.",
    tech: [
      "Unreal Engine 5",
      "C++",
      "Blueprints",
      "Game Architecture",
      "System Design",
      "Content Creation",
      "Technical Education",
    ],
  },
  {
    id: 1,
    company: "LSEG (London Stock Exchange Group)",
    logo: lseg,
    title: "Software Engineer",
    startDate: "2024-06-01",
    endDate: "Present",
    location: "Malabe, Western Province, Sri Lanka · On-site",
    description:
      "Contributing to the development of high-performance, low-latency trading systems. Primarily focused on C++ enterprise solutions, building scalable and reliable financial infrastructure for large-scale markets.",
    tech: [
      "C",
      "C++",
      "Python",
      "Java",
      "Node.js",
      "Golang",
      "Spring Boot",
      "Microservices",
      "PostgreSQL",
      "Cucumber (BDD)",
      "Jest",
      "Bash",
      "Linux",
      "Jenkins",
      "AWS",
    ],
  },
  {
    id: 2,
    company: "elseware Games",
    logo: elseware_games,
    title: "Founder",
    startDate: "2020-01-01",
    endDate: "Present",
    location: "Colombo, Western Province, Sri Lanka · On-site",
    description:
      "Leading the development of Unreal Engine assets, tools, plugins, subsystems, and games. Oversee product strategy, technical direction, and team management across design and engineering.",
    tech: ["Unreal Engine", "Blueprints", "C++", "Game Design"],
  },
  {
    id: 3,
    company: "Maggie's Farm Incorporated",
    logo: maggiesfarm_studio,
    title: "Gameplay Engineer",
    startDate: "2024-01-01",
    endDate: "2024-06-01",
    location: "Vancouver, Canada · Remote",
    description:
      "Worked as a gameplay engineer on a contract basis, implementing core gameplay mechanics and optimizing performance for game systems.",
    tech: ["Unreal Engine", "C++", "Game Physics", "AI Systems"],
  },
  {
    id: 4,
    company: "University of Colombo School of Computing",
    logo: ucsc,
    title: "Undergraduate Teaching Assistant",
    startDate: "2023-11-01",
    endDate: "2024-03-01",
    location: "Colombo, Western Province, Sri Lanka · On-site",
    description:
      "Contributed to Data Structures and Algorithms practical sessions for UCSC undergraduates of the academic year 20(AY20).",
    tech: ["C", "C++", "Data Structures", "Algorithms"],
  },
  {
    id: 5,
    company: "IncBotic",
    logo: incbotic,
    title: "Software Engineer",
    startDate: "2022-08-01",
    endDate: "2023-11-01",
    location: "Mount Lavinia, Western Province, Sri Lanka · Remote",
    description:
      "Built and maintained scalable backend microservices with Moleculer (Node.js). Optimized PostgreSQL databases and managed AWS-based deployments, improving system performance and reliability.",
    tech: ["Node.js", "Moleculer", "PostgreSQL", "AWS"],
  },
  {
    id: 6,
    company: "WSO2",
    logo: wso2,
    title: "Software Engineer Intern",
    startDate: "2022-11-01",
    endDate: "2023-04-01",
    location: "Sri Lanka · On-site",
    description:
      "Worked at WSO2 Open Healthcare, gaining hands-on experience with healthcare data standards such as FHIR, HL7, and X12. Contributed to data integration and interoperability solutions.",
    tech: ["Java", "FHIR", "HL7", "X12", "API Development"],
  },
];

// Add calculated durations
EXPERIENCES.forEach((exp) => {
  exp.duration = `${new Date(exp.startDate).toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  })} - ${
    exp.endDate === "Present"
      ? "Present"
      : new Date(exp.endDate).toLocaleString("en-US", {
          month: "short",
          year: "numeric",
        })
  } · ${calculateDuration(exp.startDate, exp.endDate)}`;
});
